<template>
  <div
    class="p-3 bg-white card multisteps-form__panel border-radius-xl"
    data-animation="FadeIn"
  >
    <h5 class="font-weight-bolder">Massas</h5>
    <div class="multisteps-form__content">
      <div class="col-12 row" style="padding-top:0%">
        <div class="col-12" v-for="(horario,index) in $parent.produto.massas" v-bind:key="index">
          <div class="row">
            <div class="col-12 col-sm-2">
              <label>Nome</label>
              <input
                class="multisteps-form__input form-control"
                type="text"
                v-model="$parent.produto.massas[index].nome"
              />
            </div>
            <div class="col-12 col-sm-2">
              <label>Situação</label>
              <select
                id="choices-catalogo-ifood"
                class="form-control"
                name="choices-catalogo-ifood"
                v-model="$parent.produto.massas[index].status"
              >
                <option v-bind:value="true" v-bind:selected="$parent.produto.massas[index].status">Ativo</option>
                <option v-bind:value="false"  v-bind:selected="!$parent.produto.massas[index].status">Inativo</option>
              </select>
            </div>

            <div class="col-2">
                <label>Delivery</label>
                <vue-numeric-input 
                    className="multisteps-form__input form-control"
                    :controls="false"
                    placeholder="99.00"
                    v-model="$parent.produto.massas[index].valores[1].valor_desconto"
                    :precision="2"
                />
            </div>
            <div class="col-2">
                <label>Ifood</label>
                <vue-numeric-input 
                    className="multisteps-form__input form-control"
                    :controls="false"
                    placeholder="99.00"
                    v-model="$parent.produto.massas[index].valores[2].valor_desconto"
                    :precision="2"
                />
            </div>
            <div class="col-12 col-sm-1"
                style="    padding-top: 4%;">
              <soft-button
                type="button"
                color="secondary"
                variant="gradient"
                class="mb-0 js-btn-prev"
                title="Prev"
                @click="$parent.removerMassa(index)"
                ><i class="fa fa-minus"></i></soft-button
              >
            </div>
          </div>
        </div>
        <div class="mt-4 button-row d-flex col-12">
          <soft-button
              type="button"
              color="dark"
              variant="gradient"
              class="mb-0 ms-auto js-btn-next"
              title="Next"
              @click="this.$parent.adicionarMassa"
              ><i class="fa fa-plus"></i></soft-button
            >
      </div>
      </div>
      <div class="row">
        <div class="mt-4 button-row d-flex col-12">
          <soft-button
            type="button"
            color="secondary"
            variant="gradient"
            class="mb-0 js-btn-prev"
            title="Prev"
            @click="this.$parent.prevStep"
            >Anterior</soft-button
          >
          <soft-button
            type="button"
            color="dark"
            variant="gradient"
            class="mb-0 ms-auto js-btn-next"
            title="Next"
            @click="this.$parent.nextStep"
            >Próximo</soft-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SoftInput from "@/novocomponents/SoftInput.vue";
import SoftButton from "@/novocomponents/SoftButton.vue";
export default {
  name: "Massas",
  components: {
    // SoftInput,
    SoftButton,
  },
  async mounted() {
    console.log(this.$parent.produto)
  }
};
</script>
